module.exports = __webpack_public_path__ + "img/bespoke123_31.577b1eca.jpg";